import { FAVORITES_KEY } from './constants';

export class LocalFavoritesRepo {
    async isFavorite(userId: string, listingId: string): Promise<boolean> {
        const map = this.loadFavorites();
        const list = map[userId] || [];
        return list.includes(listingId);
    }

    async addFavorite(userId: string, listingId: string): Promise<boolean> {
        const map = this.loadFavorites();
        if (!map[userId]) map[userId] = [];
        if (!map[userId].includes(listingId)) {
            map[userId].push(listingId);
            this.saveFavorites(map);
        }
        return true;
    }

    async removeFavorite(userId: string, listingId: string): Promise<boolean> {
        const map = this.loadFavorites();
        if (!map[userId]) return false;

        const idx = map[userId].indexOf(listingId);
        if (idx !== -1) {
            map[userId].splice(idx, 1);
            this.saveFavorites(map);
            return true;
        }
        return false;
    }

    async getFavorites(userId: string): Promise<string[]> {
        const map = this.loadFavorites();
        return map[userId] || [];
    }

    private loadFavorites(): Record<string, string[]> {
        try {
            const s = localStorage.getItem(FAVORITES_KEY);
            return s ? JSON.parse(s) : {};
        } catch { return {}; }
    }

    private saveFavorites(f: Record<string, string[]>) {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(f));
    }
}
